
import { MutationOptions, useMutation } from 'react-query';
import { useAuth } from '../context/AuthContext';
import { APIError, APIResponse, API_URL, post } from '../api';
import { User } from '../@types';


interface HookConfig {
  autoUpdateUser?: boolean;
}

function useUpdateAccount(
  options?: MutationOptions<APIResponse<User>, APIError, Record<any, any>>,
  config: HookConfig = { autoUpdateUser: true }
) {
  const { setUser } = useAuth();

  const {
    mutate: updateAccount,
    isLoading: updatingAccount,
    isError: isUpdatingAccountError,
    error: updateAccountError,
  } = useMutation(
    async (variables) => {
      const token = localStorage.getItem('token');
      return await post(API_URL + '/account/user/account/update', variables, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
    },
    {
      onSettled(data) {
        
        if (config.autoUpdateUser && data?.data) {
          setUser(data.data);
        }
      },
      ...options,
    }
  );

  return {
    updateAccount,
    updatingAccount,
    isUpdatingAccountError,
    updateAccountError,
  };
}

export default useUpdateAccount;